import { mdlOtherAgencyCreateRequest } from "../models/service-models/otherAgency/OtherAgencyCreateRequest";
import { mdlOtherAgencyCreateResponse } from "../models/service-models/otherAgency/OtherAgencyCreateResponse";
import { mdlOtherAgencyDeleteRequest } from "../models/service-models/otherAgency/OtherAgencyDeleteRequest";
import { mdlOtherAgencyDeleteResponse } from "../models/service-models/otherAgency/OtherAgencyDeleteResponse";
import { mdlOtherAgencyDetailRequest } from "../models/service-models/otherAgency/OtherAgencyDetailRequest";
import { mdlOtherAgencyDetailResponse } from "../models/service-models/otherAgency/OtherAgencyDetailResponse";
import { mdlOtherAgencyListRequest } from "../models/service-models/otherAgency/OtherAgencyListRequest";
import { mdlOtherAgencyListResponse } from "../models/service-models/otherAgency/OtherAgencyListResponse";
import { mdlOtherAgencyUpdateRequest } from "../models/service-models/otherAgency/OtherAgencyUpdateRequest";
import { mdlOtherAgencyUpdateResponse } from "../models/service-models/otherAgency/OtherAgencyUpdateResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { GetResponse } from "../utils/ApiClient";
import { mdlSaveOtherAgencyListRequest } from "../models/service-models/otherAgency/SaveOtherAgencyListRequest";
import { mdlSaveOtherAgencyListResponse } from "../models/service-models/otherAgency/SaveOtherAgencyListResponse";

namespace OtherAgencyService {
    export async function Create(
        pRequest: mdlOtherAgencyCreateRequest
    ): Promise<mdlServiceResponse<mdlOtherAgencyCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOtherAgencyCreateResponse>>(
            "otherAgency/create",
            pRequest
        );
    }

    export async function Update(
        pRequest: mdlOtherAgencyUpdateRequest
    ): Promise<mdlServiceResponse<mdlOtherAgencyUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOtherAgencyUpdateResponse>>(
            "otherAgency/update",
            pRequest
        );
    }

    export async function Delete(
        pRequest: mdlOtherAgencyDeleteRequest
    ): Promise<mdlServiceResponse<mdlOtherAgencyDeleteResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOtherAgencyDeleteResponse>>(
            "otherAgency/delete",
            pRequest
        );
    }

    export async function List(
        pRequest: mdlOtherAgencyListRequest
    ): Promise<mdlServiceResponse<mdlOtherAgencyListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOtherAgencyListResponse>>(
            "otherAgency/list",
            pRequest
        );
    }

    export async function Detail(
        pRequest: mdlOtherAgencyDetailRequest
    ): Promise<mdlServiceResponse<mdlOtherAgencyDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlOtherAgencyDetailResponse>>(
            "otherAgency/detail",
            pRequest
        );
    }
    export async function SaveOtherAgencyList(
        pRequest: mdlSaveOtherAgencyListRequest
    ): Promise<mdlServiceResponse<mdlSaveOtherAgencyListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlSaveOtherAgencyListResponse>>(
            "otherAgency/save-other-agency-list",
            pRequest
        );
    }
}
export { OtherAgencyService };
